import { render, staticRenderFns } from "./SettlementPlatformChart.vue?vue&type=template&id=5bbc2403&scoped=true"
import script from "./SettlementPlatformChart.vue?vue&type=script&lang=js"
export * from "./SettlementPlatformChart.vue?vue&type=script&lang=js"
import style0 from "./SettlementPlatformChart.vue?vue&type=style&index=0&id=5bbc2403&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbc2403",
  null
  
)

export default component.exports